// SPDX-License-Identifier: AGPL-3.0-or-later
import Accessibility, {type AccessibilitySettings} from '@app/features/accessibility/state/Accessibility';

type AccessibilityPatch = Partial<AccessibilitySettings>;

function applyAccessibilityPatch(settings: AccessibilityPatch): void {
	Accessibility.updateSettings(settings);
}

export function update(settings: AccessibilityPatch): void {
	applyAccessibilityPatch(settings);
}
